import React from 'react'
import ListNewsArticles from '../../Services/Queries/ListNewsArticles'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import _ from 'lodash'
import '../../App.css'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import UpdateArticleStatus from '../../Services/Mutations/UpdateArticleStatus'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import DisplayButtons from './DisplayButtons'
import DisplayArticleDetails from './DisplayArticleDetails'
import moment from 'moment'
import FilterArticles from './FilterArticles'
import InitiateCrawlingService from '../../Services/Mutations/InitiateCrawlingService'
import ListConfiguredSitesAndCtegories from '../../Services/Queries/ListConfiguredSitesAndCtegories'
import { DefinedPermissions } from '../Constants/Permissions'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'

const styles = {
  fontSize: {
    fontSize: '12px',
  },
}
class ListArticles extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    firstIndex: 0,
    lastIndex: 0,
  }
  constructor(props) {
    super(props)

    this.state = {
      selectedArticles: [],
      selectedArticlesItems: [],
      filtered: false,
      modalVisible: false,
      limit: 100,
      loading: true,
      endReached: false,
      loadMore: false,
      props: props,
      backlogNextToken: null,
      p0NextToken: null,
      p1NextToken: null,
      p2NextToken: null,
      completedNextToken: null,
      notGoodNextToken: null,
      backlogArticlesList: [],
      notGoodArticlesList: [],
      p0ArticlesList: [],
      p1ArticlesList: [],
      p2ArticlesList: [],
      completedArticlesList: [],
      backlogCategories: [],
      notGoodCategories: [],
      p0Categories: [],
      p1Categories: [],
      p2Categories: [],
      completedCategories: [],
      backlogSiteNames: [],
      notGoodSiteNames: [],
      p0SiteNames: [],
      p1SiteNames: [],
      p2SiteNames: [],
      completedSiteNames: [],
      copiedValue: '',
      copied: false,
      articleType: '',
      draggedArticleId: '',
      draggedFrom: '',
      isDisabled: false,
      filterStatusTypes: ['backlog', 'p0', 'p1', 'p2', 'notGood', 'completed'],
      configuredSitesAndCategoriesList: { configuredCategories: [], configuredSites: [] },
      showAll: false,
      loggedInUserPermissions: [],
    }
  }

  getAllArticlesList = (statusTypes) => {
    statusTypes.map(async (statusType, index) => {
      let listName = `${statusType}ArticlesList`
      let categoryName = `${statusType}Categories`
      let siteName = `${statusType}SiteNames`
      let nextToken = `${statusType}NextToken`
      const { limit } = this.state
      const input = {
        limit: limit,
        nextToken: null,
        filterBy: statusType,
      }
      console.log(input, 'input=======')

      const articlesListResponse = await ListNewsArticles(input)
      console.log(articlesListResponse, 'articlesListResponse=======')
      let Categories = []
      let siteNames = []
      if (articlesListResponse && articlesListResponse.items) {
        articlesListResponse.items.map((item) => {
          item.pnPriority = 'Off'
          if (item.category) {
            Categories.push(item.category)
          }
          if (item.siteName) {
            siteNames.push(item.siteName)
          }
        })
      }

      this.setState({
        loading: false,
        [listName]: articlesListResponse.items,
        [categoryName]: _.uniq(Categories),
        [siteName]: _.uniq(siteNames),
        [nextToken]: articlesListResponse.nextToken,
      })
    })
  }

  getNextArticles = async (statusTypes) => {
    statusTypes.map(async (statusType, index) => {
      let listName = `${statusType}ArticlesList`
      let categoryName = `${statusType}Categories`
      let siteName = `${statusType}SiteNames`
      let tokenName = `${statusType}NextToken`
      const nextToken = this.getNextToken(statusType)
      const { limit } = this.state
      const input = {
        limit: limit,
        nextToken: nextToken,
        filterBy: statusType,
      }
      console.log(input, 'input=======')

      const articlesListResponse = await ListNewsArticles(input)
      console.log(articlesListResponse, 'articlesListResponse=======')
      let Categories = []
      let siteNames = []
      if (articlesListResponse && articlesListResponse.items) {
        articlesListResponse.items.map((item) => {
          item.pnPriority = 'Off'
          if (item.category) {
            Categories.push(item.category)
          }
          if (item.siteName) {
            siteNames.push(item.siteName)
          }
        })
      }
      const articles = this.getArticleType(statusType)
      const finalItems = [...articles, ...articlesListResponse.items]
      this.setState({
        loading: false,
        [listName]: [...new Set(finalItems)],
        [categoryName]: _.uniq(Categories),
        [siteName]: _.uniq(siteNames),
        [tokenName]: articlesListResponse.nextToken,
      })
    })
  }
  getArticlesList = async () => {
    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    const userPermissions = await GetUserPermissions(permissionInput)
    let permissions = []
    let permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item) => {
        permissions.push(...item.permissions)
      })
      permissions.map((permission) => {
        permissionsArr.push(permission.name)
      })
    }
    this.setState({
      selectedArticles: [],
      selectedArticlesItems: [],
      filtered: false,
      loading: true,
      endReached: false,
      copiedValue: '',
      copied: false,
      articleType: '',
      draggedArticleId: '',
      draggedFrom: '',
      isDisabled: false,
      loggedInUserPermissions: permissionsArr,
    })
    await this.getAllArticlesList(this.state.filterStatusTypes)
  }

  componentDidMount = async () => {
    let configuredSitesAndCategoriesList = await ListConfiguredSitesAndCtegories()
    let configuredSiteNames = configuredSitesAndCategoriesList.configuredSites
    let configuredCategories = configuredSitesAndCategoriesList.configuredCategories
    configuredSitesAndCategoriesList = {
      configuredCategories: configuredCategories ? configuredCategories : [],
      configuredSites: configuredSiteNames ? configuredSiteNames : [],
    }
    this.setState({ configuredSitesAndCategoriesList })
    console.log(configuredSitesAndCategoriesList, 'configuredSitesAndCategoriesList')
    await this.getArticlesList()
  }

  selectAllItems = (type) => {
    let selectedArticleType = this.getArticleType(type)
    if (this.state.selectedArticles.length > 0) {
      this.setState(
        {
          selectedArticles: [],
          selectedArticlesItems: [],
        },
        () => {
          this.getCopyText(false)
        }
      )
    } else {
      this.setState({ articleType: type, copied: false, copiedValue: '' })
      let selectedArticleType = this.getArticleType(type)

      let selectedArticles = this.state.selectedArticles
      let selectedArticlesItems = selectedArticleType
      selectedArticleType.map((item, index) => {
        selectedArticles.push(item.SK)
      })

      const uniqueArticlesItems = _.uniq(selectedArticlesItems)
      let finalArticleItemsArr = []
      let finalArticleIdsArr = []
      uniqueArticlesItems.map((articleItem) => {
        if (articleItem.newsarticleStatus == type) {
          finalArticleItemsArr.push(articleItem)
          finalArticleIdsArr.push(articleItem.SK)
        }
      })

      this.setState(
        {
          selectedArticles: finalArticleIdsArr,
          selectedArticlesItems: finalArticleItemsArr,
          selectedArticleType: type,
          articleType: type,
        },
        () => {
          this.getCopyText(false)
        }
      )
    }
  }
  selectArticles = (e, type, index, item) => {
    this.setState({ articleType: type, copied: false, copiedValue: '' })
    const { firstIndex } = this.state
    let selectedArticleType = this.getArticleType(type)

    if (!e.shiftKey && !e.ctrlKey) {
      this.setState({ firstIndex: index })
    }
    let selectedArticles = e.shiftKey ? [] : this.state.selectedArticles
    let selectedArticlesItems = e.shiftKey ? [] : this.state.selectedArticlesItems

    if (e.shiftKey) {
      const finalIndex = index
      const arr = [firstIndex, finalIndex]
      const sortedArr = _.sortBy(arr)
      for (let i = sortedArr[0]; i <= sortedArr[1]; i = i + 1) {
        selectedArticles.push(selectedArticleType[i].SK)
        selectedArticlesItems.push(selectedArticleType[i])
      }
    }

    if (!e.shiftKey) {
      const indexIndex = selectedArticles.findIndex((lang) => lang == selectedArticleType[index].SK)
      if (selectedArticles.includes(selectedArticleType[index].SK)) {
        selectedArticles.splice(indexIndex, 1)
        selectedArticlesItems.splice(indexIndex, 1)
      } else {
        selectedArticles.push(selectedArticleType[index].SK)
        selectedArticlesItems.push(selectedArticleType[index])
      }
    }

    const uniqueArticlesItems = _.uniq(selectedArticlesItems)
    let finalArticleItemsArr = []
    let finalArticleIdsArr = []
    uniqueArticlesItems.map((articleItem) => {
      if (articleItem.newsarticleStatus == type) {
        finalArticleItemsArr.push(articleItem)
        finalArticleIdsArr.push(articleItem.SK)
      }
    })

    this.setState(
      {
        selectedArticles: finalArticleIdsArr,
        selectedArticlesItems: finalArticleItemsArr,
        selectedArticleType: type,
      },
      () => {
        this.getCopyText(false)
      }
    )
  }
  getCopyText = (isSingle) => {
    const {
      selectedArticlesItems,
      selectedSingleArticleType,
      selectedSingleArticleIndex,
    } = this.state
    let itemToMove = {}
    if (selectedSingleArticleType) {
      let articleData = this.getArticleType(selectedSingleArticleType)
      itemToMove = articleData[selectedSingleArticleIndex]
    }
    let selectedItems = isSingle ? [itemToMove] : selectedArticlesItems
    let text = ''
    selectedItems.map((item, index) => {
      const articleUrl = item.newsarticleURL
      const articleTitle = item.title
      const pnPriority = item.pnPriority ? '\n' + 'PN Priority : ' + item.pnPriority : ''
      const article = articleTitle + ' ' + articleUrl + pnPriority + '\n---------------\n'

      text = text + article
      this.setState({ copiedValue: text })
    })
  }
  getArticleType = (type) => {
    const {
      notGoodArticlesList,
      backlogArticlesList,
      p0ArticlesList,
      p1ArticlesList,
      p2ArticlesList,
      completedArticlesList,
    } = this.state
    let articleType = backlogArticlesList
    if (type == 'notGood') {
      articleType = notGoodArticlesList
    } else if (type == 'p0') {
      articleType = p0ArticlesList
    } else if (type == 'p1') {
      articleType = p1ArticlesList
    } else if (type == 'p2') {
      articleType = p2ArticlesList
    } else if (type == 'completed') {
      articleType = completedArticlesList
    }
    return articleType
  }
  getNextToken = (type) => {
    const {
      notGoodNextToken,
      backlogNextToken,
      p0NextToken,
      p1NextToken,
      p2NextToken,
      completedNextToken,
    } = this.state
    let nextToken = backlogNextToken
    if (type == 'notGood') {
      nextToken = notGoodNextToken
    } else if (type == 'p0') {
      nextToken = p0NextToken
    } else if (type == 'p1') {
      nextToken = p1NextToken
    } else if (type == 'p2') {
      nextToken = p2NextToken
    } else if (type == 'completed') {
      nextToken = completedNextToken
    }
    return nextToken
  }
  getcategoryType = (type) => {
    const {
      notGoodCategories,
      backlogCategories,
      p0Categories,
      p1Categories,
      p2Categories,
      completedCategories,
    } = this.state
    let categoryType = backlogCategories
    if (type == 'notGood') {
      categoryType = notGoodCategories
    } else if (type == 'p0') {
      categoryType = p0Categories
    } else if (type == 'p1') {
      categoryType = p1Categories
    } else if (type == 'p2') {
      categoryType = p2Categories
    } else if (type == 'completed') {
      categoryType = completedCategories
    }
    return categoryType
  }
  getSiteNameType = (type) => {
    const {
      notGoodSiteNames,
      backlogSiteNames,
      p0SiteNames,
      p1SiteNames,
      p2SiteNames,
      completedSiteNames,
    } = this.state
    let siteNameType = backlogSiteNames
    if (type == 'notGood') {
      siteNameType = notGoodSiteNames
    } else if (type == 'p0') {
      siteNameType = p0SiteNames
    } else if (type == 'p1') {
      siteNameType = p1SiteNames
    } else if (type == 'p2') {
      siteNameType = p2SiteNames
    } else if (type == 'completed') {
      siteNameType = completedSiteNames
    }
    return siteNameType
  }
  handleCopy = () => {
    this.setState({ copied: true }, () => {
      setTimeout(() => {
        this.setState({ copied: false })
      }, 2000)
    })
  }
  handleCopyAndMoveToCompleted = (moveFrom, moveTo) => {
    this.setState({ copied: true }, () => {
      this.moveArticles(moveFrom, moveTo)
      setTimeout(() => {
        this.setState({ copied: false })
      }, 2000)
    })
  }
  handleDrag = (e) => {
    const draggedArticleId = e.currentTarget.attributes['sk'].value
    const draggedFrom = e.currentTarget.attributes['articlestatus'].value
    this.setState({ draggedArticleId: draggedArticleId, draggedFrom: draggedFrom })
  }
  handleDrop = async (e) => {
    const { draggedArticleId, draggedFrom, selectedArticlesItems } = this.state
    let droppedArticleId = e.currentTarget.attributes['sk'].value
    let droppedTo = e.currentTarget.attributes['articlestatus'].value
    // const permittedUser = Auth.user.attributes.phone_number == '+919491870436'
    const moveArticleFromBacklogPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['moveArticleFromBacklogPermission']
    )
    const dragAndDropArticlesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['dragAndDropArticlesPermission']
    )

    if (draggedFrom == 'backlog' && droppedTo == 'completed' && !moveArticleFromBacklogPermission) {
      toast.error('You dont have permission to move article to completed ', this.toastStyle)
      this.setState({ loading: false })
    } else if (!dragAndDropArticlesPermission) {
      toast.error('You dont have permission to drag and drop articles ', this.toastStyle)
      this.setState({ loading: false })
    } else {
      let moveFromArticleType = this.getArticleType(draggedFrom)
      let moveFromArticleIndex = moveFromArticleType.findIndex(
        (data) => data.SK == draggedArticleId
      )
      let moveFromArticleData = moveFromArticleType[moveFromArticleIndex]
      let moveToArticleType = this.getArticleType(droppedTo)
      let moveToArticleIndex = moveToArticleType.findIndex((data) => data.SK == droppedArticleId)
      let moveToArticleData =
        moveToArticleIndex != 0
          ? moveToArticleType[moveToArticleIndex - 1]
          : moveToArticleType[moveToArticleIndex]
      let articlesToMove =
        selectedArticlesItems.length > 0 ? selectedArticlesItems : [moveFromArticleData]
      let loggedInUserHandle = ''
      let loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split('@')
        loggedInUserHandle = '@' + emailParams[0]
        let finalInput = []
        this.setState({ loading: true })

        articlesToMove.map(async (item, index) => {
          const input = {
            PK: 'newsarticles',
            SK: item.SK,
            newsarticleStatus: droppedTo,
            newsarticleStatusUpdatedBy: loggedInUserHandle,
            newsarticleSortTime: moveToArticleData.newsarticleSortTime - parseInt(index + 1),
          }
          finalInput.unshift(input)
        })
        console.log(finalInput, 'finalInputeeee')
        const finInput = {
          articles: finalInput,
        }
        const response = await UpdateArticleStatus(finInput)
        console.log(response, 'responseeee')
        if (response.statusCode == 'A316') {
          toast.success('Moved Article Successfully', this.toastStyle)

          finalInput.map(async (item, index) => {
            if (this.state.selectedArticlesItems.length > 0) {
              moveFromArticleIndex = moveFromArticleType.findIndex((data) => data.SK == item.SK)
              moveFromArticleData = moveFromArticleType[moveFromArticleIndex]
            }
            // if (true) {
            moveFromArticleType.splice(moveFromArticleIndex, 1)
            let toIndex = index == 0 ? moveToArticleIndex : parseInt(moveToArticleIndex + index)
            moveToArticleType.splice(parseInt(toIndex), 0, moveFromArticleData)
            moveToArticleType.map((item) => {
              item.newsarticleStatus = droppedTo
            })
            let selectedArticles = this.state.selectedArticles
            let selectedArticlesItems = this.state.selectedArticlesItems

            selectedArticles.splice(moveFromArticleIndex, 1)
            selectedArticlesItems.splice(moveFromArticleIndex, 1)
            this.setState({
              [moveToArticleType]: moveToArticleType,
              [moveFromArticleType]: [moveFromArticleType],
              selectedArticles: selectedArticles,
              selectedArticlesItems: selectedArticlesItems,
              modalVisible: false,
              loading: false,
            })
          })
        } else {
          this.setState({ loading: false })
          toast.error('Failed To Move Article', this.toastStyle)
        }
      }
    }
  }
  moveArticles = async (moveFrom, moveTo) => {
    const {
      selectedArticlesItems,
      selectedSingleArticleIndex,
      selectedSingleArticleType,
    } = this.state
    // const permittedUser = Auth.user.attributes.phone_number == '+919491870436'
    const moveArticleFromBacklogPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['moveArticleFromBacklogPermission']
    )
    const dragAndDropArticlesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['dragAndDropArticlesPermission']
    )
    if (moveFrom == 'backlog' && moveTo == 'completed' && !moveArticleFromBacklogPermission) {
      toast.error('You dont have access to move article to completed', this.toastStyle)
      this.setState({ loading: false })
    } else if (!dragAndDropArticlesPermission) {
      toast.error('You dont have access to drag and drop articles', this.toastStyle)
      this.setState({ loading: false })
    } else {
      //moving multiple articles at once

      let moveToArticleType = this.getArticleType(moveTo)
      let moveFromArticleType = this.getArticleType(moveFrom)
      let itemToMove = {}
      if (selectedSingleArticleType) {
        let articleData = this.getArticleType(selectedSingleArticleType)
        itemToMove = articleData[selectedSingleArticleIndex]
      }
      let articlesToMove = selectedArticlesItems.length > 0 ? selectedArticlesItems : [itemToMove]
      let loggedInUserHandle = ''
      const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split('@')
        loggedInUserHandle = '@' + emailParams[0]
        let finalInput = []
        this.setState({ loading: true })
        articlesToMove.map(async (item, index) => {
          const input = {
            PK: 'newsarticles',
            SK: item.SK,
            newsarticleStatus: moveTo,
            newsarticleStatusUpdatedBy: loggedInUserHandle,
            newsarticleSortTime: item.newsarticleSortTime,
          }
          console.log(input, 'inputeeee')
          finalInput.unshift(input)
        })
        console.log(finalInput, 'finalInputeeee')
        const finInput = {
          articles: finalInput,
        }
        const response = await UpdateArticleStatus(finInput)
        console.log(response, 'responseeee')
        if (response.statusCode == 'A316') {
          toast.success('Moved Article Successfully', this.toastStyle)

          finalInput.map(async (item, index) => {
            const itemIndex = moveFromArticleType.findIndex((data) => data.SK == item.SK)
            const selecteditem = moveFromArticleType[itemIndex]
            moveFromArticleType.splice(itemIndex, 1)
            moveToArticleType.unshift(selecteditem)
            moveToArticleType.map((item) => {
              item.newsarticleStatus = moveTo
            })
            this.setState({
              [moveToArticleType]: moveToArticleType,
              [moveFromArticleType]: [moveFromArticleType],
              selectedArticles: [],
              selectedArticlesItems: [],
              modalVisible: false,
              loading: false,
            })
          })
        } else {
          this.setState({ loading: false })
          toast.error('Failed To Move Article', this.toastStyle)
        }
      } else {
        toast.error('No user handle found', this.toastStyle)
      }
    }
  }
  openModalAndSetData = (item, index, type) => {
    this.setState(
      {
        modalVisible: true,
        selectedSingleArticleIndex: index,
        selectedSingleArticleType: item.newsarticleStatus,
        articleType: type,
      },
      () => {
        this.getCopyText(true)
      }
    )
  }
  setArticlePnType = (priority) => {
    const {
      selectedSingleArticleIndex,
      selectedSingleArticleType,
      selectedArticlesItems,
    } = this.state

    let moveFromArticleType = this.getArticleType(selectedSingleArticleType)
    moveFromArticleType[selectedSingleArticleIndex].pnPriority = priority

    if (this.state.selectedArticlesItems.length > 0) {
      const indexIndex = selectedArticlesItems.findIndex(
        (data) => data.SK == moveFromArticleType[selectedSingleArticleIndex].SK
      )
      if (selectedArticlesItems[indexIndex]) {
        selectedArticlesItems[indexIndex].pnPriority = priority
      }
    }
    this.setState(
      {
        modalVisible: false,
        [moveFromArticleType]: moveFromArticleType,
        selectedArticlesItems: selectedArticlesItems,
      },
      () => {
        this.getCopyText(false)
      }
    )
  }
  closeModal = () => {
    this.setState({ modalVisible: false })
  }

  filterArticles = async (filterFrom, selectedCategory, selectedSiteName, selectedTime) => {
    const { limit } = this.state
    let filterInput = {
      limit: limit,
      nextToken: null,
      filterBy: filterFrom,
    }
    if (selectedCategory) {
      filterInput['category'] = selectedCategory
    }
    if (selectedSiteName) {
      filterInput['siteName'] = selectedSiteName
    }
    if (Object.keys(selectedTime).length > 0) {
      filterInput['fromTime'] = selectedTime.fromTime
      filterInput['toTime'] = selectedTime.toTime
    }
    if (selectedCategory && selectedSiteName && Object.keys(selectedTime).length > 0) {
      filterInput['searchBy'] = 'siteNameCategoryAndTime'
    } else if (this.state.showAll && selectedCategory && selectedSiteName) {
      filterInput['searchBy'] = 'siteNameFromAllAndCategory'
    } else if (selectedCategory && selectedSiteName) {
      filterInput['searchBy'] = 'siteNameAndCategory'
    } else if (selectedSiteName && Object.keys(selectedTime).length > 0) {
      filterInput['searchBy'] = 'siteNameAndTime'
    } else if (selectedCategory && Object.keys(selectedTime).length > 0) {
      filterInput['searchBy'] = 'categoryAndTime'
    } else if (selectedCategory) {
      filterInput['searchBy'] = 'category'
    } else if (this.state.showAll) {
      filterInput['searchBy'] = 'siteNameFromAll'
    } else if (selectedSiteName) {
      filterInput['searchBy'] = 'siteName'
    } else if (Object.keys(selectedTime).length > 0) {
      filterInput['searchBy'] = 'time'
    }
    console.log(filterInput, 'filterInput')
    const filteredList = await ListNewsArticles(filterInput)
    console.log(filteredList, 'filteredList')
    const list = filterFrom + 'ArticlesList'
    this.setState({ [list]: filteredList.items })
  }
  resetFilter = async (filterType) => {
    await this.getAllArticlesList([filterType])
  }
  showAll = (showAll) => {
    this.setState({ showAll: showAll })
  }
  initiateCrawling = async () => {
    this.setState({ isDisabled: true })
    if (!this.state.isDisabled) {
      const crawlInput = {
        sync: true,
      }
      const response = await InitiateCrawlingService(crawlInput)
      if (response.statusCode == 'A315') {
        toast.success('Sync Started Successfully', this.toastStyle)
      } else {
        toast.error('Failed to start Sync', this.toastStyle)
      }
    }
  }
  renderTableRow = (item, index, type) => {
    const { selectedArticles } = this.state
    const timeago = moment(new Date(item.newsarticleSortTime * 1000)).fromNow()
    const createdDate = timeago
    const displayBackgroundColor = selectedArticles.includes(item.SK) ? 'rgba(0, 0, 0, 0.13)' : null
    const className = selectedArticles.includes(item.SK) ? 'far fa-check-circle' : 'far fa-circle'
    return (
      <DisplayArticleDetails
        handleDrag={this.handleDrag}
        handleDrop={this.handleDrop}
        key={`article${index}${item.SK}`}
        selectArticles={this.selectArticles}
        openModalAndSetData={this.openModalAndSetData}
        createdDate={createdDate}
        index={index}
        item={item}
        displayBackgroundColor={displayBackgroundColor}
        className={className}
        type={type}
      />
    )
  }
  renderModal = () => {
    const { modalVisible } = this.state
    const { selectedSingleArticleIndex, selectedSingleArticleType } = this.state

    const moveFromArticleType = this.getArticleType(selectedSingleArticleType)
    const displayBackgroundColor = moveFromArticleType[selectedSingleArticleIndex].pnPriority
      ? true
      : false
    return (
      <Modal show={modalVisible} onHide={() => this.closeModal()}>
        <Modal.Body>
          <div>
            <div>
              <label>Choose Pn Type for this article</label>
            </div>
            <div class='buttonsClass mb-2'>
              <text
                size='sm'
                style={{
                  backgroundColor:
                    displayBackgroundColor &&
                    moveFromArticleType[selectedSingleArticleIndex].pnPriority == 'Off'
                      ? '#53c453d6'
                      : '',
                }}
                class='mr-2 chipType'
                onClick={() => this.setArticlePnType('Off')}
              >
                Off
              </text>
              <text
                size='sm'
                style={{
                  backgroundColor:
                    displayBackgroundColor &&
                    moveFromArticleType[selectedSingleArticleIndex].pnPriority == 'Regular'
                      ? '#53c453d6'
                      : '',
                }}
                class='mr-2 chipType'
                onClick={() => this.setArticlePnType('Regular')}
              >
                Regular
              </text>
              <text
                size='sm'
                style={{
                  backgroundColor:
                    displayBackgroundColor &&
                    moveFromArticleType[selectedSingleArticleIndex].pnPriority == 'Major'
                      ? '#53c453d6'
                      : '',
                }}
                class='mr-2 chipType'
                onClick={() => this.setArticlePnType('Major')}
              >
                Major
              </text>
              <text
                size='sm'
                style={{
                  backgroundColor:
                    displayBackgroundColor &&
                    moveFromArticleType[selectedSingleArticleIndex].pnPriority == 'ForAll'
                      ? '#53c453d6'
                      : '',
                }}
                class='mr-2 chipType'
                onClick={() => this.setArticlePnType('ForAll')}
              >
                For All
              </text>
            </div>
            <div>
              <div>
                <label>Move To</label>
              </div>
              <DisplayButtons
                handleCopyAndMoveToCompleted={this.handleCopyAndMoveToCompleted}
                handleCopy={this.handleCopy}
                moveFrom={this.state.articleType}
                moveArticles={this.moveArticles}
                copiedValue={this.state.copiedValue}
                copied={this.state.copied}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    )
  }
  handleDroptoSideBox = async (e) => {
    const { draggedArticleId, draggedFrom, selectedArticlesItems } = this.state
    // let droppedArticleId = e.currentTarget.attributes['sk'].value
    let droppedTo = e.currentTarget.attributes['articlestatus'].value
    // const permittedUser = Auth.user.attributes.phone_number == '+919491870436'
    const moveArticleFromBacklogPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['moveArticleFromBacklogPermission']
    )
    const dragAndDropArticlesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['dragAndDropArticlesPermission']
    )
    if (draggedFrom == 'backlog' && droppedTo == 'completed' && !moveArticleFromBacklogPermission) {
      toast.error('You dont have access to move article to completed', this.toastStyle)
      this.setState({ loading: false })
    } else if (!dragAndDropArticlesPermission) {
      toast.error('You dont have access to drag and drop articles', this.toastStyle)
      this.setState({ loading: false })
    } else {
      let moveFromArticleType = this.getArticleType(draggedFrom)
      let moveToArticleType = this.getArticleType(droppedTo)

      let moveFromArticleIndex = moveFromArticleType.findIndex(
        (data) => data.SK == draggedArticleId
      )
      let moveFromArticleData = moveFromArticleType[moveFromArticleIndex]

      let articlesToMove =
        selectedArticlesItems.length > 0 ? selectedArticlesItems : [moveFromArticleData]
      let loggedInUserHandle = ''
      let loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split('@')
        loggedInUserHandle = '@' + emailParams[0]
        this.setState({ loading: true })
        let finalInput = []
        articlesToMove.map(async (item, index) => {
          const input = {
            PK: 'newsarticles',
            SK: item.SK,
            newsarticleStatus: droppedTo,
            newsarticleStatusUpdatedBy: loggedInUserHandle,
            newsarticleSortTime: item.newsarticleSortTime - parseInt(index + 1),
          }
          finalInput.unshift(input)
        })
        console.log(finalInput, 'finalInputeeee')
        const finInput = {
          articles: finalInput,
        }
        const response = await UpdateArticleStatus(finInput)
        console.log(response, 'responseeee')
        if (response.statusCode == 'A316') {
          toast.success('Moved Article Successfully', this.toastStyle)

          finalInput.map(async (item, index) => {
            if (this.state.selectedArticlesItems.length > 0) {
              moveFromArticleIndex = moveFromArticleType.findIndex((data) => data.SK == item.SK)
              moveFromArticleData = moveFromArticleType[moveFromArticleIndex]
            }
            // if (true) {
            moveFromArticleType.splice(moveFromArticleIndex, 1)
            moveToArticleType.unshift(moveFromArticleData)

            moveToArticleType.map((item) => {
              item.newsarticleStatus = droppedTo
            })
            let selectedArticles = this.state.selectedArticles
            let selectedArticlesItems = this.state.selectedArticlesItems

            selectedArticles.splice(moveFromArticleIndex, 1)
            selectedArticlesItems.splice(moveFromArticleIndex, 1)
            this.setState({
              [moveToArticleType]: moveToArticleType,
              [moveFromArticleType]: [moveFromArticleType],
              selectedArticles: selectedArticles,
              modalVisible: false,
              selectedArticlesItems: selectedArticlesItems,
              loading: false,
            })
          })
        } else {
          this.setState({ loading: false })
          toast.error('Failed To Move Article', this.toastStyle)
        }
      }
    }
  }

  render() {
    const syncArticlesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['syncArticlesPermission']
    )
    return (
      <div>
        {this.state.loading ? <div class='loading'>Loading;</div> : null}
        <ToastContainer
          position='top-right'
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {this.state.modalVisible ? this.renderModal() : null}
        <div class='container-fluid'>
          <div class='mainContainer mt-3'>
            {this.state.filterStatusTypes.map((articleType, index) => {
              let articleList = this.getArticleType(articleType)
              let articleTypeSiteNames = this.getSiteNameType(articleType)
              let articleTypeCategories = this.getcategoryType(articleType)
              let articleTypeNextToken = this.getNextToken(articleType)
              return (
                <div class='d-flex' key={index}>
                  <div class='moveBlockMainDiv'>
                    {articleType != 'p0' ? (
                      <div
                        draggable={true}
                        id={index}
                        articlestatus={'p0'}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDrop={(ev) => this.handleDroptoSideBox(ev)}
                        class='moveBlock  mb-2 mr-2'
                      >
                        P0
                      </div>
                    ) : null}
                    {articleType != 'p1' ? (
                      <div
                        draggable={true}
                        id={index}
                        articlestatus={'p1'}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDrop={(ev) => this.handleDroptoSideBox(ev)}
                        class='moveBlock  mb-2 mr-2'
                      >
                        P1
                      </div>
                    ) : null}
                    {articleType != 'p2' ? (
                      <div
                        draggable={true}
                        id={index}
                        articlestatus={'p2'}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDrop={(ev) => this.handleDroptoSideBox(ev)}
                        class='moveBlock  mb-2 mr-2'
                      >
                        P2
                      </div>
                    ) : null}
                    {articleType != 'notGood' ? (
                      <div
                        draggable={true}
                        id={index}
                        articlestatus={'notGood'}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDrop={(ev) => this.handleDroptoSideBox(ev)}
                        class='moveBlock  mb-2 mr-2'
                      >
                        Not Good
                      </div>
                    ) : null}
                    {articleType != 'completed' ? (
                      <div
                        draggable={true}
                        id={index}
                        articlestatus={'completed'}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDrop={(ev) => this.handleDroptoSideBox(ev)}
                        class='moveBlock  mb-2 mr-2'
                      >
                        Completed
                      </div>
                    ) : null}
                  </div>
                  <div class='mainDiv' key={articleType.SK}>
                    {articleList ? (
                      <div class={`${articleType}Articles`}>
                        <div class='d-flex articleColumn justify-content-between'>
                          <label>{articleType} Articles</label>
                          {articleList.length > 0 ? (
                            <input
                              type='checkbox'
                              checked={
                                this.state.articleType == articleType &&
                                this.state.selectedArticles.length > 0 &&
                                this.state.selectedArticles.length == articleList.length
                              }
                              onChange={() => {
                                this.selectAllItems(articleType)
                              }}
                            ></input>
                          ) : null}

                          {articleType == 'backlog' ? (
                            <>
                              {syncArticlesPermission ? (
                                <small>
                                  <i
                                    onClick={() => {
                                      this.initiateCrawling()
                                    }}
                                    class='iconStyle fas fa-sync'
                                  />
                                </small>
                              ) : null}
                              <small>
                                <i
                                  onClick={() => {
                                    this.getArticlesList()
                                  }}
                                  class='iconStyle fas fa-redo'
                                />
                              </small>
                            </>
                          ) : null}
                          {articleList.length > 0 || this.state.filtered ? (
                            <FilterArticles
                              key={articleType.SK}
                              categories={articleTypeCategories}
                              siteNames={articleTypeSiteNames}
                              filterArticles={this.filterArticles}
                              configuredSitesAndCategoriesList={
                                this.state.configuredSitesAndCategoriesList
                              }
                              showAll={this.showAll}
                              resetFilter={this.resetFilter}
                              filterFrom={articleType}
                            />
                          ) : null}
                        </div>
                        {this.state.selectedArticles.length > 0 &&
                        this.state.articleType == articleType ? (
                          <div class='d-flex w-100 buttonsClass mb-2'>
                            <DisplayButtons
                              key={articleType.SK}
                              handleCopyAndMoveToCompleted={this.handleCopyAndMoveToCompleted}
                              handleCopy={this.handleCopy}
                              moveFrom={articleType}
                              moveArticles={this.moveArticles}
                              copiedValue={this.state.copiedValue}
                              copied={this.state.copied}
                            />
                          </div>
                        ) : null}
                        <div class='articlesrows'>
                          {articleList &&
                            articleList.map((row, index) =>
                              this.renderTableRow(row, index, articleType)
                            )}
                        </div>
                        {articleTypeNextToken != null ? (
                          <Button
                            style={{
                              fontSize: 10,
                              padding: 5,
                            }}
                            onClick={() => this.getNextArticles([articleType])}
                          >
                            Load More
                          </Button>
                        ) : null}
                      </div>
                    ) : !this.state.loading ? (
                      <div>No Data To Display</div>
                    ) : null}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default ListArticles
